(function () {
    'use strict';

    angular
        .module('auth',
            [
                'ui.router',
                'ui.bootstrap',
                'ngMask',
                'ngRoute'
            ]);

})();